import axios_nomura from "./axios-nomura.services";

// Portfolio Page
export const fetchPortfolioGroups = async (data) => {
  let convertDataToJson = JSON.stringify(data);
  return await axios_nomura.post(`api/v1/portfolios/groups`, convertDataToJson);
};

export const fetchNavPortfolios = async (data) => {
  let convertDataToJson = JSON.stringify(data);
  return await axios_nomura.post(`api/v1/nav/portfolios`, convertDataToJson);
};

// Portfolio Statistics
export const fetchPreviousReturnByAccount = async (accountNumber) => {
  return await axios_nomura.get(
    `api/v1/portfolios/${accountNumber}/previous_return`
  );
};
export const fetchPreviousReturnGraphByAccount = async (
  accountNumber,
  data
) => {
  return await axios_nomura.get(
    `api/v1/portfolios/${accountNumber}/previous_return/graph`,
    {
      params: {
        startAt: data.startAt ?? "",
        endAt: data.endAt ?? "",
        dateType: data.dateType ?? "",
      },
    }
  );
};
export const fetchAumGraphByAccount = async (accountNumber, data) => {
  return await axios_nomura.get(
    `api/v1/portfolios/${accountNumber}/aum/graph`,
    {
      params: {
        startAt: data.startAt ?? "",
        endAt: data.endAt ?? "",
        dateType: data.dateType ?? "",
      },
    }
  );
};
export const fetchMonthlyReturnByAccount = async (accountNumber) => {
  return await axios_nomura.get(
    `api/v1/portfolios/${accountNumber}/monthly_return`
  );
};
export const fetchProfitByAccount = async (accountNumber) => {
  return await axios_nomura.get(`api/v1/portfolios/${accountNumber}/profit`);
};
export const fetchVolatilityByAccount = async (accountNumber) => {
  return await axios_nomura.get(
    `api/v1/portfolios/${accountNumber}/volatility`
  );
};
export const fetchMaxDrawdownByAccount = async (accountNumber) => {
  return await axios_nomura.get(
    `api/v1/portfolios/${accountNumber}/max_drawdown`
  );
};
export const fetchDrawdownByAccount = async (accountNumber, data) => {
  return await axios_nomura.get(`api/v1/portfolios/${accountNumber}/drawdown`, {
    params: { startAt: data.startAt ?? "", endAt: data.endAt ?? "" },
  });
};
export const fetchLastDateOfAccountNumber = async (accountNumber) => {
  return await axios_nomura.get(
    `api/v1/portfolios/${accountNumber}/latest_data_date`
  );
};

// Order Page
export const fetchOrders = async (data) => {
  return await axios_nomura.get(`api/v1/orders`, { params: data });
};

export const uploadOrderDocument = async (orderNumber, data) => {
  let formData = new FormData();
  formData.append("file", data[0]);
  return await axios_nomura.post(
    `api/v1/orders/${orderNumber}/upload`,
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );
};

export const deleteOrderRequestFund = async (data) => {
  return await axios_nomura.post(`api/v1/orders/${data.accountNumber}/cancel`, {
    number: data.number,
    fundCode: data.fundCode,
  });
};

export const getOrderAttachment = async (orderNumber) => {
  return await axios_nomura.get(`api/v1/orders/${orderNumber}/attachment`, {
    responseType: "blob",
  });
};

// Lot Page
export const fetchLots = async (data) => {
  return await axios_nomura.get(`api/v1/portfolios/lots`, { params: data });
};

// Book Page
export const fetchBooks = async (data) => {
  // return await axios_nomura.get(`api/v2/portfolios/books`, {params: data});
  return await axios_nomura.post(`api/v1/portfolios/books`, data);
};

// Histories Page
export const fetchHistories = async (data) => {
  return await axios_nomura.get(`api/v1/portfolios/trades`, {
    params: {
      accountNumbers: data.accountNumbers,
      fundCodes: data.fundCodes,
      startedAt: data.startedAt ?? "",
      endedAt: data.endedAt ?? "",
      sortBy: data.sortBy,
      sortType: data.sortType,
      status: data.status,
      isRemarkExists: data.remark,
    },
  });
};

// DCAs Page
export const fetchDCAs = async (payload) => {
  return await axios_nomura.get(`api/v1/portfolios/dca`, { params: payload });
};

export const deleteDCAOrderRequestFund = async (data) => {
  return await axios_nomura.post(
    `api/v1/orders/${data.accountNumber}/cancel_dca`,
    {
      number: data.number,
      fundCode: data.fundCode,
    }
  );
};

// Dividend Page
export const fetchDividends = async (data) => {
  return await axios_nomura.get(`api/v1/portfolios/dividends`, {
    params: {
      accountNumbers: data.accountNumbers,
      startedAt: data.startedAt ?? "",
      endedAt: data.endedAt ?? "",
      fundIds: data.fundIds,
      sortBy: data.sortBy,
      sortType: data.sortType,
    },
  });
};

// Get Actived Funds By Accounts
export const fetchActivedFunds = async (accountNumbers) => {
  return await axios_nomura.get(`api/v1/portfolios/funds?`, {
    params: { accountNumbers: accountNumbers },
  });
};

// Get All Funds By Accoutns
export const fetchAllFunds = async (accountNumbers) => {
  return await axios_nomura.get(`api/v1/accounts/funds?`, {
    params: { accountNumbers: accountNumbers },
  });
};

// Get All Fund Codes
export const fetchAllFundCodes = async () => {
  return await axios_nomura.get(`api/v1/funds?`);
};
